import { writable } from "svelte/store";

export const aboutOpen = writable(false);
